import React from 'react';
import { Link } from 'react-router-dom';

const ArticleCard = ({ article, isLarge = false }) => {
    const authorImageUrl = article.author?.image?.asset?.url;
    const authorName = article.author?.name || 'Admin';

    if (isLarge) {
        return (
            <article className="flex flex-col grow shrink rounded-lg bg-blend-normal w-full lg:w-[356px]">
                <div className="flex overflow-hidden flex-col rounded-lg bg-blend-normal w-full lg:w-[445px]">
                    <img
                        loading="lazy"
                        src={article.mainImage?.asset?.url}
                        alt={article.title}
                        className="object-cover w-full h-full rounded-sm bg-blend-normal aspect-square"
                    />
                </div>

                <div className="flex flex-col mt-5 w-full bg-blend-normal max-w-[445px] text-neutral-900 max-md:max-w-full">
                    <div className="flex gap-3 w-full text-sm bg-blend-normal">
                        <img
                            loading="lazy"
                            src={authorImageUrl}
                            alt={authorName}
                            className="object-cover shrink-0 w-8 h-8 bg-blend-normal rounded-full"
                        />
                        <div className="flex-auto my-auto w-[395px]">{authorName}</div>
                    </div>
                    <h3 className="flex flex-col pr-2.5 pb-1 mt-3 w-full text-base font-bold bg-blend-normal">
                        <Link to={article.slug.current} className="hover:underline">{article.title}</Link>
                    </h3>
                </div>
            </article>
        );
    }

    return (
        <article className="flex flex-row lg:flex-row mt-8 lg:mt-0 gap-2 lg:gap-6 items-start lg:mb-4 max-w-full rounded-lg bg-blend-normal w-full">
            <div className="flex overflow-hidden flex-col items-center w-80 h-24 lg:w-40 lg:h-40 rounded-lg bg-blend-normal bg-neutral-200">
                <img
                    loading="lazy"
                    src={article.mainImage?.asset?.url}
                    alt={article.title}
                    className="object-cover w-full h-full rounded-sm bg-blend-normal"
                />
            </div>
            <div className="flex flex-col grow shrink bg-blend-normal min-w-[240px] text-neutral-900 w-full md:w-[413px]">
                <div className="flex gap-3 max-w-full text-sm bg-blend-normal">
                    <img
                        loading="lazy"
                        src={authorImageUrl}
                        alt={authorName}
                        className="object-cover shrink-0 w-8 h-8 bg-blend-normal aspect-square rounded-full"
                    />
                    <div className="flex-auto my-auto">{authorName}</div>
                </div>
                <h3 className="flex flex-col pr-2 pb-2 mt-3 max-w-full text-sm lg:text-base font-bold bg-blend-normal">
                    <Link to={article.slug?.current} className="hover:underline">{article.title}</Link>
                </h3>
            </div>
        </article>
    );
};

export default ArticleCard;
